Vue.component('MfaIndexComponent', require('./components/MfaIndexComponent').default);
Vue.component('VerifyCodeComponent', require('./components/email/VerifyCodeComponent.vue').default);
Vue.component('MfaManagementComponent', require('./components/MfaManagementComponent.vue').default);
